module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://game-assets.hub.novafutur.com/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if (typeof game_assets !== 'undefined') return resolve();
    __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof game_assets !== 'undefined') return resolve();
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        reject(__webpack_error__);
      },
      "game_assets",
    );
  }).then(function () {
    const proxy = {
      get: game_assets.get,
      init: function(shareScope) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          game_assets.init(new Proxy(shareScope, handler))
        } catch (e) {

        }
        game_assets.__initialized = true
      }
    }
    if (!game_assets.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });